export enum LogoutTypes {
  LOGOUT_REQUESTED = "logout/REQUESTED",
}

export interface ILogoutRequestedAction {
  type: typeof LogoutTypes.LOGOUT_REQUESTED;
}

export type LogoutActions = ILogoutRequestedAction;
